<template>
<div id="viewer">
  <tools-viewer v-bind:viewer="viewer" v-on:showOrHideInventryGeneratorSideBar="showOrHideInventryGeneratorSideBar()" 
  v-on:showOrHideMapCommentSideBar="showOrHideMapCommentSideBar()"></tools-viewer>
  <side-bar-viewer v-if="currentInventoryEntry"></side-bar-viewer>
  <side-bar-map-comment v-if="showMapCommentSideBar"></side-bar-map-comment>
  <side-bar-inventry-generator v-if="showInventryGeneratorSideBar"></side-bar-inventry-generator>
  <div id="osdViewer" class="osdViewer">
  </div>
</div>
</template>

<script>
import OpenSeadragon from 'openseadragon'
import { svgOverlay } from 'svg-overlay'
import { mapGetters } from 'vuex'
import ToolsViewer from './ToolsViewer'
import SideBarViewer from './sideBarViewer/SideBarViewer'
import SideBarMapComment from '@components/commons/sideBarMapComment/SideBarMapComment'
import SideBarInventryGenerator from '@components/commons/sideBarInventryGenerator/SideBarInventryGenerator'
import EventBus from '@components/bus/bus.js';
import * as d3 from 'd3'

export default {
  name: 'SeadragonViewer',
  components: { ToolsViewer, SideBarViewer, SideBarMapComment, SideBarInventryGenerator },
  data() {
    return {
      viewer: null,
      showMapCommentSideBar: false,
      showInventryGeneratorSideBar: false
    }
  },
  computed: {
    ...mapGetters({
      tileSources: 'getTileSources',
      index: 'getIndex',
      currentInventoryEntry: 'getCurrentInventoryEntry',
      inventoryEntryToZoom: 'getInventoryEntryToZoom'
    })
  },
  watch: {
    inventoryEntryToZoom() {
      if (this.inventoryEntryToZoom) {
        // En attendant de comprendre ce qui ne fonctionne pas avec zoomTo
        d3.selectAll('circle').remove();
        let d3Circle = d3.select(this.viewer.svgOverlay().node()).append('circle')
          .attr('cx', this.inventoryEntryToZoom.xViewport)
          .attr('fill-opacity', 0.7)
          .attr('cy', this.inventoryEntryToZoom.yViewport)
          .attr('r', 0.009)
          .style('fill','red')
      // this.zoomTo(new OpenSeadragon.Point(this.inventoryEntryToZoom.xViewport, this.inventoryEntryToZoom.yViewport))
      }
    }
  },
  mounted() {
    this.viewer = OpenSeadragon({
        id: 'osdViewer',
        sequenceMode: true,
        initialPage: this.index,
        tileSources: [this.tileSources],
        defaultZoomLevel: 0.4,
        maxZoomLevel: 14,
        minZoomLevel: 0,
        preserveViewport: true,
        showNavigator: true,
        navigatorPosition: 'ABSOLUTE',
        navigatorTop: '40px',
        navigatorLeft: '25px',
        navigatorHeight: '120px',
        navigatorWidth: '145px',
        autoHideControls: false,
        prefixUrl: 'http://openseadragon.github.io/openseadragon/images/'
      }),
      this.viewer.addHandler('page', event => {
         this.$store.dispatch('updateIndex', event.page),
         // Rétablissement des valeurs par défaut
         this.$store.dispatch('updateCurrentInventoryEntry', null)
         this.$store.commit('UPDATE_MODE_ACTIVATION', false)
         if(this.showInventryGeneratorSideBar){
           this.showOrHideInventryGeneratorSideBar()
           this.$store.dispatch('resetInventryGenerator')
         }
         if(this.showMapCommentSideBar){
           this.showOrHideMapCommentSideBar()
         }
         d3.selectAll('circle').remove();
        }
       )
    this.viewer.addHandler("canvas-double-click", this.doubleTapHandler);
    this.viewer.gestureSettingsMouse.clickToZoom = false;
    this.$store.dispatch('setOverlay', this.viewer.svgOverlay())
    EventBus.$on('showOrHideMapCommentSideBar', this.showOrHideMapCommentSideBar)
    EventBus.$on('showOrHideInventryGeneratorSideBar', this.showOrHideInventryGeneratorSideBar)
  },
  methods: {
    // zoom sur l'entrée d'inventaire
    zoomTo(point) {
      this.viewer.viewport.zoomTo(3, point, true)
    },
    // Double click dans le viewport
    doubleTapHandler: function(event) {
      if(this.showInventryGeneratorSideBar) {
        this.$store.dispatch('displayRefPointCircle', this.viewer.viewport.pointFromPixel(event.position))
      }
    },
    // Fonction qui permet d'ouvrir et de fermer le componsant de commentaires de cartes
    showOrHideMapCommentSideBar: function() {
      this.showMapCommentSideBar = !this.showMapCommentSideBar
    },
    // Permet d'ouvrir et fermer composant permettant de générer les entrées d'inventaires d'une carte
    showOrHideInventryGeneratorSideBar: function() {
      this.showInventryGeneratorSideBar = !this.showInventryGeneratorSideBar
    }
  }
}
</script>
<style>
.osdViewer {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: darkgrey;
}

#viewer {
  margin-top: 105px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/SeadragonViewer.vue